import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import MetaTags from './meta/MetaTags.jsx'
import './App.css'

function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const tiles = Array.from(document.querySelectorAll('.features-grid .feature-tile'))
    if (!tiles.length) return

    const updateActiveTile = () => {
      const viewportCenter = window.scrollY + window.innerHeight / 2
      let closest = null
      let closestDistance = Number.POSITIVE_INFINITY

      tiles.forEach((tile) => {
        const rect = tile.getBoundingClientRect()
        const tileCenter = rect.top + window.scrollY + rect.height / 2
        const distance = Math.abs(tileCenter - viewportCenter)
        if (distance < closestDistance) {
          closestDistance = distance
          closest = tile
        }
      })

      tiles.forEach((tile) => {
        const shouldHighlight = tile === closest && closestDistance < window.innerHeight * 0.6
        tile.classList.toggle('feature-tile--active', !!shouldHighlight)
      })
    }

    updateActiveTile()
    window.addEventListener('scroll', updateActiveTile, { passive: true })
    window.addEventListener('resize', updateActiveTile)

    return () => {
      window.removeEventListener('scroll', updateActiveTile)
      window.removeEventListener('resize', updateActiveTile)
    }
  }, [])

  return (
    <>
      <MetaTags profileKey="home" />

      <main>
        {/* Hero */}
        <section id="hero" className="section hero">
          <h2 className="title">Plan Parties Together, Effortlessly</h2>
          <p className="subtitle">Free social planner to invite friends, vote on plans, and stay in sync with a shared timeline.</p>
          <Link to="/planner" className="btn primary large">Start Planning</Link>
        </section>

        {/* Why PartyDecider */}
        <section id="why" className="section why">
          <h2 className="section-title">Why PartyDecider?</h2>
          <p className="section-tagline">One link. One plan. Everyone's on the same page.</p>
          <div className="features-grid">
            <div className="feature-tile">
              <div className="feature-icon">📊</div>
              <h3>Polls</h3>
              <p>Vote on options together</p>
            </div>
            <div className="feature-tile">
              <div className="feature-icon">✓</div>
              <h3>Tasks</h3>
              <p>Assign and track to-dos</p>
            </div>
            <div className="feature-tile">
              <div className="feature-icon">📅</div>
              <h3>Shared Timeline</h3>
              <p>See the whole plan at a glance</p>
            </div>
            <div className="feature-tile">
              <div className="feature-icon">✉️</div>
              <h3>RSVP</h3>
              <p>Track who's coming</p>
            </div>
            <div className="feature-tile">
              <div className="feature-icon">📝</div>
              <h3>Notes</h3>
              <p>Keep details in one place</p>
            </div>
          </div>
          
          <div className="why-cta-section">
            <p className="why-description">
              PartyDecider is an event planning platform with digital invites, shared timelines and high-profile guest
              management, built to keep every detail organized and every guest in sync.
            </p>
            <Link to="/planner" className="btn outline small">
              ✨ Start Planning — No Download Required
            </Link>
          </div>
        </section>

        {/* PartyPack Grid */}
        <section id="games" className="section games">
          <div className="partypack-header">
            <span className="partypack-badge">PartyPack</span>
            <h2 className="section-title">Tools That Bring It Together</h2>
          </div>
          <div className="games-grid-compact">
            <Link to="/whoispaying" className="game-card-compact">
              <div className="game-icons-row-compact">
                <span className="game-icon-compact">🎲</span>
                <span className="game-icon-divider">or</span>
                <span className="game-icon-compact">🃏</span>
              </div>
              <h3>Who Is Paying?</h3>
              <p>Settle it with dice or cards</p>
            </Link>

            <div className="game-card-compact coming-soon">
              <div className="game-icon-compact">🎟️</div>
              <h3>Raffle Tickets</h3>
              <p>Group draws for events</p>
              <span className="badge">Coming Soon</span>
            </div>

            <div className="game-card-compact coming-soon">
              <div className="game-icon-compact">⏳</div>
              <h3>Group Timer</h3>
              <p>Shared countdown challenges</p>
              <span className="badge">Coming Soon</span>
            </div>
          </div>
        </section>

        {/* About */}
        <section id="about" className="section about">
          <div className="about-divider"></div>
          <h2 className="section-title">PartyDecider helps you create the plan and the vibe.</h2>
          <p className="about-text">
            Ready to lighten the mood? Try the <span className="about-partypack-badge">PartyPack</span>, with tools like <strong>Who's Paying</strong>, <strong>Raffle Draw</strong>, and <strong>Group Timer</strong> to keep things fair and fun.
          </p>
        </section>
      </main>
    </>
  )
}

export default App
